import { createAction, handleActions } from "redux-actions";

export const types = {
  getPlugins: "GET_PLUGINS",
  setPlugins: "SET_PLUGINS",
  subscribePlugin: "SUBSCRIBE_PLUGIN",
  subscribePluginDone: "SUBSCRIBE_PLUGIN_DONE",
  getPluginSubscriptions: "GET_PLUGIN_SUBSCRIPTIONS",
  getPluginSubscriptionsDone: "GET_PLUGIN_SUBSCRIPTIONS_DONE",
  setPluginSettings: "SET_PLUGIN_SETTINGS",
  getJobServices: "GET_JOB_SERVICES",
  setJobServices: "SET_JOB_SERVICES",
  updateJobServices: "UPDATE_JOB_SERVICES",
  addJobService: "ADD_JOB_SERVICE",
  editJobService: "EDIT_JOB_SERVICE",
  addSalesPerson: "ADD_SALES_PERSON",
  editSalesPerson: "EDIT_SALES_PERSON",
  addLocation: "ADD_LOCATION",
  editLocation: "EDIT_LOCATION",
  getSalesPersons: "GET_SALES_PERSONS",
  setSalesPersons: "SET_SALES_PERSONS",
  getLocations: "GET_LOCATIONS",
  setLocations: "SET_LOCATIONS",
  setShowJobServiceModal: "SET_SHOW_JOB_SERVICE_MODAL",
  setShowManagePluginModal: "SET_SHOW_MANAGE_PLUGIN_MODAL",
  setShowJobEditServiceModal: "SET_SHOW_JOB_EDIT_SERVICE_MODAL",
  setShowSalespersonModal: "SET_SHOW_SALESPERSON_MODAL",
  setShowSalespersonEditModal: "SET_SHOW_SALESPERSON_EDIT_MODAL",
  setShowLocationModal: "SET_SHOW_LOCATION_MODAL",
  setShowLocationEditModal: "SET_SHOW_LOCATION_EDIT_MODAL",
  deleteJobService: "DELETE_JOB_SERVICE",
  deleteSalesPerson: "DELETE_SALES_PERSON",
  deleteLocation: "DELETE_LOCATION",
  cancelPluginSubscription: "CANCEL_PLUGIN_SUBSCRIPTION",
  cancelPluginSubscriptionDone: "CANCEL_PLUGIN_SUBSCRIPTION_DONE",
  updatePaymentMethodSubscription: "UPDATE_PAYMENT_METHOD_SUBSCRIPTION",
  updatePaymentMethodSubscriptionDone:
    "UPDATE_PAYMENT_METHOD_SUBSCRIPTION_DONE",
  woocommerceCreateCustomer: "WOOCOMMERCE_CREATE_CUSTOMER",
  woocommerceCreateCustomerDone: "WOOCOMMERCE_CREATE_CUSTOMER_DONE",
  woocommerceUpdateCustomer: "WOOCOMMERCE_UPDATE_CUSTOMER",
  woocommerceUpdateCustomerDone: "WOOCOMMERCE_UPDATE_CUSTOMER_DONE",
  woocommerceCreateOrder: "WOOCOMMERCE_CREATE_ORDER",
  woocommerceCreateOrderDone: "WOOCOMMERCE_CREATE_ORDER_DONE",
  woocommerceAddToOrder: "WOOCOMMERCE_ADD_TO_ORDER",
  woocommerceAddToOrderDone: "WOOCOMMERCE_ADD_TO_ORDER_DONE",
  woocommerceDeleteOrder: "WOOCOMMERCE_DELETE_ORDER",
  woocommerceDeleteOrderDone: "WOOCOMMERCE_DELETE_ORDER_DONE",
  woocommerceCheckUserExists: "WOOCOMMERCE_CHECK_USER_EXISTS",
  woocommerceCheckUserExistsDone: "WOOCOMMERCE_CHECK_USER_EXISTS_DONE",
  woocommerceCheckOrderExists: "WOOCOMMERCE_CHECK_ORDER_EXISTS",
  woocommerceCheckOrderExistsDone: "WOOCOMMERCE_CHECK_ORDER_EXISTS_DONE",
  woocommerceGetProductId: "WOOCOMMERCE_GET_PRODUCT_ID",
  woocommerceGetProductIdDone: "WOOCOMMERCE_GET_PRODUCT_ID_DONE",
  woocommerceGetProductIdFailure: "WOOCOMMERCE_GET_PRODUCT_ID_FAILURE",
  woocommerceRemoveFromOrder: "WOOCOMMERCE_REMOVE_FROM_ORDER",
  woocommerceRemoveFromOrderDone: "WOOCOMMERCE_REMOVE_FROM_ORDER_DONE",
  woocommerceCreateCustomerFailure: "WOOCOMMERCE_CREATE_CUSTOMER_FAILURE",
  woocommerceCheckSKUExists: "WOOCOMMERCE_CHECK_SKU_EXISTS",
  woocommerceCheckSKUExistsDone: "WOOCOMMERCE_CHECK_SKU_EXISTS_DONE",
  skuChangeComplete: "SKU_CHANGE_COMPLETE",
  woocommerceAddToOrderFromSKU: "WOOCOMMERCE_ADD_TO_ORDER_FROM_SKU",
  woocommerceAddToOrderFromSKUDone: "WOOCOMMERCE_ADD_TO_ORDER_FROM_SKU_DONE",
  woocommerceRemoveFromOrderBySKU: "WOOCOMMERCE_REMOVE_FROM_ORDER_BY_SKU",
  woocommerceRemoveFromOrderBySKUDone:
    "WOOCOMMERCE_REMOVE_FROM_ORDER_BY_SKU_DONE",
  woocommerceReplaceOrder: "WOOCOMMERCE_REPLACE_ORDER",
  woocommerceReplaceOrderDone: "WOOCOMMERCE_REPLACE_ORDER_DONE",
  woocommerceCreateProduct: "WOOCOMMERCE_CREATE_PRODUCT",
  woocommerceCreateProductDone: "WOOCOMMERCE_CREATE_PRODUCT_DONE",
  woocommerceCreateProductFailure: "WOOCOMMERCE_CREATE_PRODUCT_FAILURE",
  resetErrorMessage: "RESET_ERROR_MESSAGE",
  provisionSpectrePOS: "PROVISION_SPECTRE_POS",
  provisionSpectrePOSDone: "PROVISION_SPECTRE_POS_DONE",
  provisionSpectrePOSError: "PROVISION_SPECTRE_POS_ERROR",
  getProvisionStatus: "GET_PROVISION_STATUS",
  setProvisionStatus: "SET_PROVISION_STATUS",
  stopProvisionPolling: "STOP_PROVISION_POLLING",
  getSpectreposSiteStatus: "GET_SPECTREPOS_SITE_STATUS",
  setSpectreposSiteStatus: "SET_SPECTREPOS_SITE_STATUS",
  woocommerceMatchesFound: "WOOCOMMERCE_MATCHES_FOUND",
  woocommerceMatchResolved: "WOOCOMMERCE_MATCH_RESOLVED",
  woocommerceMatchPickerDismiss: "WOOCOMMERCE_MATCH_PICKER_DISMISS",
  writeSpectrePosLink: "WRITE_SPECTRE_POS_LINK",
  writeSpectrePosLinkDone: "WRITE_SPECTRE_POS_LINK_DONE",
  checkSpectrePosLink: "CHECK_SPECTRE_POS_LINK",
  woocommerceCheckBallInOpenOrder: "WOOCOMMERCE_CHECK_BALL_IN_OPEN_ORDER",
  woocommerceCheckBallInOpenOrderDone:
    "WOOCOMMERCE_CHECK_BALL_IN_OPEN_ORDER_DONE",
  spectreposOrderFailed: "SPECTREPOS_ORDER_FAILED",
  spectreposOpenOrder: "SPECTREPOS_OPEN_ORDER",
};

export const getPlugins = createAction(types.getPlugins);
export const setPlugins = createAction(types.setPlugins);
export const subscribePlugin = createAction(types.subscribePlugin);
export const subscribePluginDone = createAction(types.subscribePluginDone);
export const getPluginSubscriptions = createAction(
  types.getPluginSubscriptions,
);
export const getPluginSubscriptionsDone = createAction(
  types.getPluginSubscriptionsDone,
);
export const setPluginSettings = createAction(types.setPluginSettings);
export const getJobServices = createAction(types.getJobServices);
export const setJobServices = createAction(types.setJobServices);
export const updateJobServices = createAction(types.updateJobServices);
export const getSalesPersons = createAction(types.getSalesPersons);
export const setSalesPersons = createAction(types.setSalesPersons);
export const getLocations = createAction(types.getLocations);
export const setLocations = createAction(types.setLocations);
export const addJobService = createAction(types.addJobService);
export const editJobService = createAction(types.editJobService);
export const addSalesPerson = createAction(types.addSalesPerson);
export const editSalesPerson = createAction(types.editSalesPerson);
export const addLocation = createAction(types.addLocation);
export const editLocation = createAction(types.editLocation);
export const setShowJobServiceModal = createAction(
  types.setShowJobServiceModal,
);
export const setShowManagePluginModal = createAction(
  types.setShowManagePluginModal,
);
export const setShowJobEditServiceModal = createAction(
  types.setShowJobEditServiceModal,
);
export const setShowSalespersonModal = createAction(
  types.setShowSalespersonModal,
);
export const setShowSalespersonEditModal = createAction(
  types.setShowSalespersonEditModal,
);
export const setShowLocationModal = createAction(types.setShowLocationModal);
export const setShowLocationEditModal = createAction(
  types.setShowLocationEditModal,
);
export const deleteJobService = createAction(types.deleteJobService);
export const deleteSalesPerson = createAction(types.deleteSalesPerson);
export const deleteLocation = createAction(types.deleteLocation);
export const cancelPluginSubscription = createAction(
  types.cancelPluginSubscription,
);
export const cancelPluginSubscriptionDone = createAction(
  types.cancelPluginSubscriptionDone,
);
export const updatePaymentMethodSubscription = createAction(
  types.updatePaymentMethodSubscription,
);
export const updatePaymentMethodSubscriptionDone = createAction(
  types.updatePaymentMethodSubscriptionDone,
);
export const woocommerceCreateCustomer = createAction(
  types.woocommerceCreateCustomer,
);
export const woocommerceCreateCustomerDone = createAction(
  types.woocommerceCreateCustomerDone,
);
export const woocommerceUpdateCustomer = createAction(
  types.woocommerceUpdateCustomer,
);
export const woocommerceUpdateCustomerDone = createAction(
  types.woocommerceUpdateCustomerDone,
);
export const woocommerceCreateOrder = createAction(
  types.woocommerceCreateOrder,
);
export const woocommerceCreateOrderDone = createAction(
  types.woocommerceCreateOrderDone,
);
export const woocommerceAddToOrder = createAction(types.woocommerceAddToOrder);
export const woocommerceAddToOrderDone = createAction(
  types.woocommerceAddToOrderDone,
);
export const woocommerceDeleteOrder = createAction(
  types.woocommerceDeleteOrder,
);
export const woocommerceDeleteOrderDone = createAction(
  types.woocommerceDeleteOrderDone,
);
export const woocommerceCheckUserExists = createAction(
  types.woocommerceCheckUserExists,
);
export const woocommerceCheckUserExistsDone = createAction(
  types.woocommerceCheckUserExistsDone,
);
export const woocommerceCheckOrderExists = createAction(
  types.woocommerceCheckOrderExists,
);
export const woocommerceCheckOrderExistsDone = createAction(
  types.woocommerceCheckOrderExistsDone,
);
export const woocommerceGetProductId = createAction(
  types.woocommerceGetProductId,
);
export const woocommerceGetProductIdDone = createAction(
  types.woocommerceGetProductIdDone,
);
export const woocommerceGetProductIdFailure = createAction(
  types.woocommerceGetProductIdFailure,
);
export const woocommerceRemoveFromOrder = createAction(
  types.woocommerceRemoveFromOrder,
);
export const woocommerceRemoveFromOrderDone = createAction(
  types.woocommerceRemoveFromOrderDone,
);
export const woocommerceCreateCustomerFailure = createAction(
  types.woocommerceCreateCustomerFailure,
);
export const woocommerceCheckSKUExists = createAction(
  types.woocommerceCheckSKUExists,
);
export const woocommerceCheckSKUExistsDone = createAction(
  types.woocommerceCheckSKUExistsDone,
);
export const skuChangeComplete = createAction(types.skuChangeComplete);
export const woocommerceAddToOrderFromSKU = createAction(
  types.woocommerceAddToOrderFromSKU,
);
export const woocommerceAddToOrderFromSKUDone = createAction(
  types.woocommerceAddToOrderFromSKUDone,
);
export const woocommerceRemoveFromOrderBySKU = createAction(
  types.woocommerceRemoveFromOrderBySKU,
);
export const woocommerceRemoveFromOrderBySKUDone = createAction(
  types.woocommerceRemoveFromOrderBySKUDone,
);
export const woocommerceReplaceOrder = createAction(
  types.woocommerceReplaceOrder,
);
export const woocommerceReplaceOrderDone = createAction(
  types.woocommerceReplaceOrderDone,
);
export const woocommerceCreateProduct = createAction(
  types.woocommerceCreateProduct,
);
export const woocommerceCreateProductDone = createAction(
  types.woocommerceCreateProductDone,
);
export const woocommerceCreateProductFailure = createAction(
  types.woocommerceCreateProductFailure,
);
export const resetErrorMessage = createAction(types.resetErrorMessage);
export const provisionSpectrePOS = createAction(types.provisionSpectrePOS);
export const provisionSpectrePOSDone = createAction(
  types.provisionSpectrePOSDone,
);
export const provisionSpectrePOSError = createAction(
  types.provisionSpectrePOSError,
);
export const getProvisionStatus = createAction(types.getProvisionStatus);
export const setProvisionStatus = createAction(types.setProvisionStatus);
export const stopProvisionPolling = createAction(types.stopProvisionPolling);
export const getSpectreposSiteStatus = createAction(
  types.getSpectreposSiteStatus,
);
export const setSpectreposSiteStatus = createAction(
  types.setSpectreposSiteStatus,
);
export const woocommerceMatchesFound = createAction(
  types.woocommerceMatchesFound,
);
export const woocommerceMatchResolved = createAction(
  types.woocommerceMatchResolved,
);
export const woocommerceMatchPickerDismiss = createAction(
  types.woocommerceMatchPickerDismiss,
);
export const writeSpectrePosLink = createAction(types.writeSpectrePosLink);
export const writeSpectrePosLinkDone = createAction(
  types.writeSpectrePosLinkDone,
);
export const checkSpectrePosLink = createAction(types.checkSpectrePosLink);
export const woocommerceCheckBallInOpenOrder = createAction(
  types.woocommerceCheckBallInOpenOrder,
);
export const woocommerceCheckBallInOpenOrderDone = createAction(
  types.woocommerceCheckBallInOpenOrderDone,
);
// A shop on HBS answered that nothing could be added to the sale (the code is
// not in the shop, there is no stock...). Carries a message ready to show.
export const spectreposOrderFailed = createAction(types.spectreposOrderFailed);
// What the shop says about a bowler's open sale: { customerId, order } with
// order null when there is none. The bowler header draws its badge from it.
export const spectreposOpenOrder = createAction(types.spectreposOpenOrder);

/**
 * The SpectrePOS provisioner returns api_url from get_site_url(), which
 * is whatever WP has stored as the blog's siteurl (currently HTTP for
 * the prod multisite). When the v3 dashboard then fetches that URL
 * directly from the browser, Cloudflare 301-redirects HTTP→HTTPS — but
 * CORS preflight responses cannot be followed across redirects per the
 * Fetch spec, so the OPTIONS preflight fails silently and the WC call
 * never goes out ("Failed to fetch"). Force HTTPS for our prod hosts
 * here. Local dev WP (shop.spectre.local, localhost) stays HTTP.
 */
const forceHttpsForSpectreposApiUrl = (url) => {
  if (!url || typeof url !== "string") return url;
  if (!/spectrebowling\.com/i.test(url)) return url;
  return url.replace(/^http:\/\//i, "https://");
};

/**
 * A plugin switch that is on by default: settings saved before the switch
 * existed do not carry it, and those shops must keep working as they did.
 */
export const switchIsOn = (value) =>
  !(value === false || value === 0 || value === "0" || value === "false");

export const INITIAL_STATE = {
  plugins: [],
  pluginSubscriptionsData: [],
  pluginSubscriptions: [],
  loading: false,
  plugin_settings: {
    job_board_default_state: "pending",
    job_board_include_price: true,
    job_board_currency: "$",
    job_board_timer: 90,
    require_serial_number: true,
    convert_layouts: true,
    require_signature: false,
    // SpectrePOS, both ways. On unless the owner turns them off in Settings.
    pos_send_from_spectre: true,
    pos_jobs_from_sales: true,
    api_url: "",
    api_key: "",
    api_secret: "",
    current_woocommerce_id: -1,
  },
  jobServices: [],
  salesPersons: [],
  locations: [],
  adding: false,
  editing: false,
  showJobEditServiceModal: false,
  selectedJobService: null,
  selectedSalesPerson: null,
  showSalespersonEditModal: false,
  showJobServiceModal: false,
  showManagePluginModal: false,
  showSalespersonModal: false,
  showLocationModal: false,
  canceling: false,
  updating: false,
  errorMessage: "",
  skuExists: false,
  productCreating: false,
  productCreateError: "",
  provisioning: false,
  provisionStatus: null,
  provisionProgress: null,
  // Where the shop lives: "hbs" (Chentro) or null/"wordpress". Changes the
  // steps the stepper shows and what the panel offers.
  provisionBackend: null,
  ownerUsername: null,
  ownerPassword: null,
  siteStatus: null,
  matchPicker: {
    open: false,
    matches: [],
    pendingPayload: null,
  },
  last_woocommerce_order_id: null,
  last_woocommerce_order_event_seq: 0,
  ball_in_order_check_seq: 0,
  ball_in_order_check_result: null,
  last_missing_inserts: [],
  last_missing_inserts_seq: 0,
  // HBS shops: the signed link that opens the sale in the register (the
  // WordPress shops build theirs from api_url + the order id instead).
  last_pos_open_url: null,
  last_pos_order_error: null,
  last_pos_order_error_seq: 0,
  // The open sale of the last bowler the shop was asked about, or null:
  // { customerId, id, code, total, items }. One slot is enough -- whoever
  // reads it checks customerId against the bowler on screen.
  pos_open_order: null,
};

export const pluginReducer = handleActions(
  {
    [types.getPlugins]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.setPlugins]: (state, action) => ({
      ...state,
      plugins: action.payload.plugins,
      loading: false,
    }),
    [types.subscribePlugin]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.subscribePluginDone]: (state) => ({
      ...state,
      loading: false,
    }),
    [types.getPluginSubscriptions]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.getPluginSubscriptionsDone]: (state, action) => ({
      ...state,
      pluginSubscriptionsData: action.payload.pluginSubscriptions,
      pluginSubscriptions: action.payload.pluginSubscriptions.reduce(
        (acc, pluginSubscription) =>
          pluginSubscription.status.toLowerCase() === "active"
            ? [
                ...acc,
                (pluginSubscription.metadata || pluginSubscription.custom_data)
                  .pluginType,
              ]
            : acc,
        [],
      ),
      loading: false,
    }),
    [types.setPluginSettings]: (state, action) => {
      const incomingStatus = action.payload.provisionStatus || null;
      const hasApiUrl = !!action.payload.plugin_settings.api_url;
      // If status is active (not ready/null), keep it; if ready or has api_url with no status, set ready
      let provisionStatus = state.provisionStatus;
      // A settings save sends only what the settings screen knows, which is
      // not where the shop lives: it arrives here as null. A known backend is
      // never forgotten because of that, or a shop on HBS would be treated as
      // a WordPress one until the next reload.
      const provisionBackend =
        action.payload.provisionBackend != null
          ? action.payload.provisionBackend
          : state.provisionBackend;
      if (incomingStatus) {
        provisionStatus =
          incomingStatus === "syncing_catalog" ? "syncing" : incomingStatus;
      } else if (hasApiUrl && !state.provisionStatus) {
        provisionStatus = "ready";
      }
      return {
        ...state,
        provisionStatus,
        provisionBackend,
        ownerUsername:
          action.payload.ownerUsername != null
            ? action.payload.ownerUsername
            : state.ownerUsername,
        ownerPassword:
          action.payload.ownerPassword != null
            ? action.payload.ownerPassword
            : state.ownerPassword,
        plugin_settings: {
          job_board_default_state:
            action.payload.plugin_settings.job_board_default_state,
          job_board_include_price:
            action.payload.plugin_settings.job_board_include_price * 1 === 1,
          job_board_currency: action.payload.plugin_settings.job_board_currency,
          job_board_timer: action.payload.plugin_settings.job_board_timer || 90,
          require_serial_number:
            action.payload.plugin_settings.require_serial_number * 1 === 1,
          convert_layouts:
            action.payload.plugin_settings.convert_layouts * 1 === 1,
          require_signature:
            action.payload.plugin_settings.require_signature * 1 === 1,
          pos_send_from_spectre: switchIsOn(
            action.payload.plugin_settings.pos_send_from_spectre,
          ),
          pos_jobs_from_sales: switchIsOn(
            action.payload.plugin_settings.pos_jobs_from_sales,
          ),
          api_url: forceHttpsForSpectreposApiUrl(
            action.payload.plugin_settings.api_url,
          ),
          api_key: action.payload.plugin_settings.api_key,
          api_secret: action.payload.plugin_settings.api_secret,
          current_woocommerce_id:
            action.payload.plugin_settings.current_woocommerce_id,
        },
      };
    },
    [types.getJobServices]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.setJobServices]: (state, action) => ({
      ...state,
      jobServices: action.payload.jobServices,
      loading: false,
      adding: false,
      editing: false,
      updating: false,
    }),
    [types.updateJobServices]: (state) => ({
      ...state,
      updating: true,
    }),
    [types.addJobService]: (state) => ({
      ...state,
      adding: true,
    }),
    [types.editJobService]: (state) => ({
      ...state,
      editing: true,
    }),
    [types.addSalesPerson]: (state) => ({
      ...state,
      adding: true,
    }),
    [types.editSalesPerson]: (state) => ({
      ...state,
      editing: true,
    }),
    [types.addLocation]: (state) => ({
      ...state,
      adding: true,
    }),
    [types.editLocation]: (state) => ({
      ...state,
      editing: true,
    }),
    [types.getSalesPersons]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.setSalesPersons]: (state, action) => ({
      ...state,
      salesPersons: action.payload.salesPersons,
      loading: false,
      adding: false,
      editing: false,
    }),
    [types.getLocations]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.setLocations]: (state, action) => ({
      ...state,
      locations: action.payload.locations,
      loading: false,
      adding: false,
      editing: false,
    }),
    [types.setShowJobServiceModal]: (state, action) => ({
      ...state,
      showJobServiceModal: action.payload.showJobServiceModal,
    }),
    [types.setShowManagePluginModal]: (state, action) => ({
      ...state,
      showManagePluginModal: action.payload.showManagePluginModal,
    }),
    [types.setShowLocationModal]: (state, action) => ({
      ...state,
      showLocationModal: action.payload.showLocationModal,
    }),
    [types.setShowLocationEditModal]: (state, action) => ({
      ...state,
      showLocationEditModal: action.payload.showLocationEditModal,
      selectedLocation: action.payload.location,
    }),
    [types.setShowSalespersonModal]: (state, action) => ({
      ...state,
      showSalespersonModal: action.payload.showSalespersonModal,
    }),
    [types.setShowJobEditServiceModal]: (state, action) => ({
      ...state,
      showJobEditServiceModal: action.payload.showJobEditServiceModal,
      selectedJobService: action.payload.jobService,
    }),
    [types.setShowSalespersonEditModal]: (state, action) => ({
      ...state,
      showSalespersonEditModal: action.payload.showSalespersonEditModal,
      selectedSalesPerson: action.payload.salesPerson,
    }),
    [types.deleteJobService]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.deleteSalesPerson]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.deleteLocation]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.cancelPluginSubscription]: (state) => ({
      ...state,
      canceling: true,
    }),
    [types.cancelPluginSubscriptionDone]: (state) => ({
      ...state,
      canceling: false,
    }),
    [types.updatePaymentMethodSubscription]: (state) => ({
      ...state,
      updating: true,
    }),
    [types.updatePaymentMethodSubscriptionDone]: (state) => ({
      ...state,
      updating: false,
    }),
    [types.woocommerceCreateCustomer]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.woocommerceCreateCustomerDone]: (state) => ({
      ...state,
      loading: false,
    }),
    [types.woocommerceUpdateCustomer]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.woocommerceUpdateCustomerDone]: (state) => ({
      ...state,
      loading: false,
    }),
    [types.woocommerceCreateOrder]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.woocommerceCreateOrderDone]: (state, action) => ({
      ...state,
      loading: false,
      last_woocommerce_order_id:
        action.payload?.orderData?.id || state.last_woocommerce_order_id,
      last_woocommerce_order_event_seq:
        state.last_woocommerce_order_event_seq + 1,
      last_pos_open_url: action.payload?.openUrl || null,
    }),
    [types.woocommerceAddToOrder]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.woocommerceAddToOrderDone]: (state, action) => ({
      ...state,
      loading: false,
      last_woocommerce_order_id:
        action.payload?.orderData?.id || state.last_woocommerce_order_id,
      last_woocommerce_order_event_seq:
        state.last_woocommerce_order_event_seq + 1,
      last_pos_open_url: action.payload?.openUrl || null,
    }),
    [types.woocommerceCheckUserExists]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.woocommerceCheckUserExistsDone]: (state, action) => ({
      ...state,
      loading: false,
      current_woocommerce_id: action.payload.customerId,
    }),
    [types.woocommerceCheckOrderExists]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.woocommerceCheckOrderExistsDone]: (state) => ({
      ...state,
      loading: false,
    }),
    [types.woocommerceGetProductId]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.woocommerceGetProductIdDone]: (state) => ({
      ...state,
      loading: false,
    }),
    [types.woocommerceGetProductIdFailure]: (state, action) => ({
      ...state,
      loading: false,
      errorMessage: action.payload.message,
    }),
    [types.woocommerceDeleteOrder]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.woocommerceDeleteOrderDone]: (state) => ({
      ...state,
      loading: false,
    }),
    [types.woocommerceRemoveFromOrder]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.woocommerceRemoveFromOrderDone]: (state) => ({
      ...state,
      loading: false,
    }),
    [types.woocommerceCreateCustomerFailure]: (state, action) => ({
      ...state,
      loading: false,
      errorMessage: action.payload.message,
    }),
    [types.woocommerceCheckSKUExists]: (state, action) => ({
      ...state,
      loading: true,
    }),
    [types.woocommerceCheckSKUExistsDone]: (state, action) => ({
      ...state,
      loading: false,
      skuExists: action.payload.skuExists,
    }),
    [types.skuChangeComplete]: (state) => ({
      ...state,
      skuExists: false,
    }),
    [types.woocommerceAddToOrderFromSKU]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.woocommerceAddToOrderFromSKUDone]: (state, action) => {
      const missing = action.payload?.missingInsertSkus || [];
      return {
        ...state,
        loading: false,
        last_missing_inserts: missing,
        last_missing_inserts_seq:
          missing.length > 0
            ? (state.last_missing_inserts_seq || 0) + 1
            : state.last_missing_inserts_seq || 0,
      };
    },
    [types.woocommerceRemoveFromOrderBySKU]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.woocommerceRemoveFromOrderBySKUDone]: (state) => ({
      ...state,
      loading: false,
    }),
    [types.woocommerceReplaceOrder]: (state) => ({
      ...state,
      loading: true,
    }),
    [types.woocommerceReplaceOrderDone]: (state) => ({
      ...state,
      loading: false,
    }),
    [types.woocommerceCreateProduct]: (state) => ({
      ...state,
      productCreating: true,
      productCreateError: "",
    }),
    [types.woocommerceCreateProductDone]: (state) => ({
      ...state,
      productCreating: false,
      productCreateError: "",
    }),
    [types.woocommerceCreateProductFailure]: (state, action) => ({
      ...state,
      productCreating: false,
      productCreateError: action.payload.message || "Failed to create product",
    }),
    [types.resetErrorMessage]: (state) => ({
      ...state,
      errorMessage: "",
    }),
    [types.provisionSpectrePOS]: (state) => ({
      ...state,
      provisioning: true,
      provisionStatus: "provisioning",
      provisionProgress: null,
    }),
    [types.provisionSpectrePOSDone]: (state, action) => ({
      ...state,
      provisioning: false,
      provisionStatus: action.payload.status || "syncing",
      provisionProgress: action.payload.progress || null,
      provisionBackend: action.payload.backend || state.provisionBackend,
      ownerUsername: action.payload.ownerUsername ?? state.ownerUsername,
      ownerPassword: action.payload.ownerPassword ?? state.ownerPassword,
    }),
    [types.provisionSpectrePOSError]: (state, action) => ({
      ...state,
      provisioning: false,
      provisionStatus: "error",
      provisionProgress: null,
      errorMessage: action.payload.message || "Provision failed",
    }),
    [types.setProvisionStatus]: (state, action) => ({
      ...state,
      provisionStatus: action.payload.status,
      provisionProgress: action.payload.progress || state.provisionProgress,
      provisionBackend: action.payload.backend || state.provisionBackend,
    }),
    [types.setSpectreposSiteStatus]: (state, action) => ({
      ...state,
      siteStatus: action.payload.siteStatus,
    }),
    [types.woocommerceMatchesFound]: (state, action) => ({
      ...state,
      loading: false,
      matchPicker: {
        open: true,
        matches: action.payload.matches || [],
        pendingPayload: action.payload.pendingPayload || null,
      },
    }),
    [types.woocommerceMatchResolved]: (state) => ({
      ...state,
      matchPicker: {
        open: false,
        matches: [],
        pendingPayload: null,
      },
    }),
    [types.woocommerceMatchPickerDismiss]: (state) => ({
      ...state,
      matchPicker: {
        open: false,
        matches: [],
        pendingPayload: null,
      },
    }),
    [types.writeSpectrePosLink]: (state) => state,
    [types.writeSpectrePosLinkDone]: (state) => state,
    [types.woocommerceCheckBallInOpenOrder]: (state) => ({
      ...state,
      ball_in_order_check_result: null,
    }),
    [types.woocommerceCheckBallInOpenOrderDone]: (state, action) => ({
      ...state,
      ball_in_order_check_seq: state.ball_in_order_check_seq + 1,
      ball_in_order_check_result: action.payload || null,
    }),
    [types.spectreposOrderFailed]: (state, action) => ({
      ...state,
      loading: false,
      last_pos_order_error: action.payload || null,
      last_pos_order_error_seq: (state.last_pos_order_error_seq || 0) + 1,
    }),
    [types.spectreposOpenOrder]: (state, action) => {
      const { customerId, order } = action.payload || {};
      return {
        ...state,
        pos_open_order: customerId && order ? { customerId, ...order } : null,
      };
    },
  },
  INITIAL_STATE,
);
